import React, { ElementType, FC } from 'react';
import { TerritoryEmptyState } from './TerritoryEmptyState';
import { useAuthenticatedUser } from '../Auth/hooks/useAuthenticatedUser';
import { EmptyStateButtonProp } from './TerritoryEmptyStateButton';
import { TerritoryVersionType } from '../../layouts/TerritoryPageLayout/TerritoryPageLayout';

export type TerritoryEmptyStateContainerProps = {
  title: string;
  description: string;
  buttonTitle: string;
  buttonUrl?: string;
  buttonAs?: ElementType;
  buttonOnClick?: () => void;
  tooltipDescription?: string;
  canCreateInTerritory: boolean;
  territorySlug: string;
  emptyStateType: EmptyStateButtonProp;
  territoryVersion: TerritoryVersionType;
};

export const TerritoryEmptyStateContainer: FC<TerritoryEmptyStateContainerProps> = ({
  title,
  description,
  buttonTitle,
  buttonUrl,
  buttonAs,
  buttonOnClick,
  canCreateInTerritory,
  emptyStateType,
  territorySlug,
  territoryVersion,
}) => {
  const { isAuthenticated } = useAuthenticatedUser();

  return (
    <TerritoryEmptyState
      title={title}
      description={description}
      isAuthenticated={isAuthenticated}
      buttonTitle={buttonTitle}
      buttonUrl={buttonUrl}
      buttonAs={buttonAs}
      buttonOnClick={buttonOnClick}
      canCreateInTerritory={canCreateInTerritory}
      emptyStateType={emptyStateType}
      territorySlug={territorySlug}
      territoryVersion={territoryVersion}
    />
  );
};
